import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            height: '100%',
            minW: remCalc(260),
            minH: remCalc(260),
            maxW: {
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            },
            maxH: {
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            },
        },
    },
    variants: {
        inModal: {
            container: {
                minW: remCalc(200),
                minH: remCalc(200),
                maxW: {
                    base: remCalc(285),
                    md: remCalc(559),
                    lg: remCalc(807),
                    xl: remCalc(807),
                },
                maxH: {
                    base: remCalc(285),
                    md: remCalc(559),
                    lg: remCalc(768),
                    xl: remCalc(768),
                },
            },
        },
    },
    parts: ['container'],
}
